import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Label,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  Fragment,
  useMemo,
} from "react";
import PropTypes from "prop-types";
import PageHeader from "../common/PageHeader";
import FalconCardHeader from "../common/FalconCardHeader";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import {
  faFileExcel,
  faFilter,
  faMoneyCheck,
  faPlus,
  faSearch,
  faToggleOn,
  faTag,
  faBook,
} from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router";
import NumberFormat from "react-number-format";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import {
  activateOrDeactivateFinances,
  deletefinance,
  fetchCommonCost,
  toggleIndividualStatus,
  update,
} from "../../helpers/api/finance";
import { findAllExchangeRates } from "../../helpers/api/currency";
import { isIterableArray } from "../../helpers/utils";
import FullPagination from "../common/pagination/FullPagination";
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { PreloadState } from "../UI/preloading/PreloadState";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SupportLink from "../root/support/components/SupportLink";
import moment from "moment";
import Swal from "sweetalert2";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { Toast } from "../UI/toast/Toast";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";
import { CurrencyContext } from "../../context/Context";
import Flex from "../common/Flex";
import Filter from "../common/Filter";
import OnboardingBanner from "../onboarding/OnboardingBanner";
import ExpenseImportModal from "./ExpenseImportModal";
import useModuleBase from "../../helpers/hooks/useModuleBase";
import { fetchAllPages } from "../../helpers/api/pagination";

const CommonCosts = ({
  setRedirect,
  setRedirectUrl,
  onEditAction,
  options,
  alternativeName,
  showPagination = true,
  ...rest
}) => {
  const moduleBase = useModuleBase();
  // Fondos de reserva monta este listado pero no sus pantallas hijas, asi
  // que desde ahi se sigue saliendo a Finanzas en vez de dar un 404.
  const childModuleBase = moduleBase === "funds" ? "finance" : moduleBase;

  const { selectedCondominium } = useSelector((state) => state.condominium);
  // El tipo de gasto viaja en el location.state desde las tarjetas de
  // Finanzas/Contabilidad. Si se entra sin él (miga de pan, URL escrita,
  // recarga) caemos a Gastos ordinarios en vez de romper la pantalla.
  const { state: locationState } = useLocation();
  const state = locationState?.type_id
    ? locationState
    : { type_id: 1, type_name: "Gastos ordinarios" };
  const history = useHistory();
  const [amount, setAmount] = useState(0);
  const [formDate, setformDate] = useState({ since: null, to: null });
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const { id } = useParams();
  const [refreshIndex, setRefreshIndex] = useState(0);
  const [ratesByDate, setRatesByDate] = useState({});
  const [latestRate, setLatestRate] = useState(null);
  const [isExpenseImportOpen, setIsExpenseImportOpen] = useState(false);

  const [params, setParams] = useState({
    state: 0,
    condominiumId: id,
    start_date: null,
    end_date: null,
    type_id: state?.type_id,
    active: 1,
  });

  const [params2, setParams2] = useState({
    state: 0,
    condominiumId: id,
    start_date: null,
    end_date: null,
    active: 1,
    type_id: state?.type_id,
  });

  const paramsWithRefresh = useMemo(
    () => ({
      ...params,
      refreshIndex,
    }),
    [params, refreshIndex]
  );

  const params2WithRefresh = useMemo(
    () => ({
      ...params2,
      refreshIndex,
    }),
    [params2, refreshIndex]
  );

  const filter_options = [
    { value: 1, displayName: "Activos", disabled: false },
    { value: 0, displayName: "Inactivos", disabled: false },
    { value: "", displayName: "Todos", disabled: false },
  ];

  const {
    data,
    isLoading,
    meta,
    mutate,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchCommonCost, paramsWithRefresh);

  const { data: otherData, mutate: mutate2 } = useSWRFetchPaginationProperty(
    fetchCommonCost,
    params2WithRefresh
  );

  const groupedData = useMemo(() => {
    if (!data || !Array.isArray(data)) return {};
    const groups = {};
    data.forEach((cost) => {
      const sub = cost.sub_expenses?.[0];
      const account = sub?.account_plan;
      const area = sub?.accounting_area;

      let groupKey = "sin-clasificar";
      let groupLabel = "Gastos Sin Clasificar";

      if (area && area.code) {
        groupKey = area.code;
        groupLabel = `${area.code} - ${area.name}`;
      } else if (account) {
        groupKey = account.code || `acc-${account.id}`;
        groupLabel = `${account.code ? account.code + " - " : ""}${area?.name || account.name}`;
      } else if (area) {
        groupKey = `area-${area.id}`;
        groupLabel = area.name;
      }

      if (!groups[groupKey]) {
        groups[groupKey] = { label: groupLabel, items: [] };
      }
      groups[groupKey].items.push(cost);
    });

    // Optional: Sort groups by code
    return Object.fromEntries(
      Object.entries(groups).sort((a, b) => a[0].localeCompare(b[0]))
    );
  }, [data]);

  useEffect(() => {
    const monto = Number(
      otherData?.reduce((a, c) => {
        return a + Number(c?.value || 0);
      }, 0) || 0
    ).toFixed(2);
    setAmount(monto);
  }, [otherData]);

  useEffect(() => {
    let isMounted = true;

    const fetchRates = async () => {
      if (!curr?.currency?.id || Number(curr?.value ?? 1) === 1) {
        if (isMounted) {
          setRatesByDate({});
          setLatestRate(null);
        }
        return;
      }

      try {
        const response = await fetchAllPages((page, pageSize) => findAllExchangeRates(page, pageSize, {
          currency: curr.currency.id,
        }));

        const rates = response?.data || [];
        const normalizedByDate = rates.reduce((acc, rate) => {
          const dateSource = rate?.date || rate?.created_at;
          const key = moment(dateSource).format("YYYY-MM-DD");
          const value = Number(rate?.value || 0);

          if (!dateSource || value <= 0) {
            return acc;
          }

          const current = acc[key];
          if (!current || moment(dateSource).valueOf() > current.sortValue) {
            acc[key] = {
              value,
              sortValue: moment(dateSource).valueOf(),
            };
          }

          return acc;
        }, {});

        const latest = rates
          .filter((rate) => Number(rate?.value || 0) > 0)
          .sort(
            (a, b) =>
              moment(b.date || b.created_at).valueOf() -
              moment(a.date || a.created_at).valueOf()
          )[0];

        if (isMounted) {
          setRatesByDate(normalizedByDate);
          setLatestRate(Number(latest?.value || 0) || null);
        }
      } catch (error) {
        if (isMounted) {
          setRatesByDate({});
          setLatestRate(Number(curr?.value ?? 0) || null);
        }
      }
    };

    fetchRates();

    return () => {
      isMounted = false;
    };
  }, [curr]);

  const resolveDisplayRate = useCallback(
    (record) => {
      const rawStoredRate =
        record?.exchange_rate?.value ?? record?.exchange_rate ?? null;
      const storedRate = Number(rawStoredRate || 0);

      if (storedRate > 0) {
        return storedRate;
      }

      const recordDate = record?.expired_at || record?.payment_date || record?.created_at;
      const dateKey = recordDate ? moment(recordDate).format("YYYY-MM-DD") : null;
      const datedRate = dateKey ? Number(ratesByDate?.[dateKey]?.value || 0) : 0;

      if (datedRate > 0) {
        return datedRate;
      }

      return Number(latestRate || curr?.value || 1);
    },
    [curr, latestRate, ratesByDate]
  );

  const ButtonAdd = ({ onClick, className }) => {
    return (
      <ButtonIcon color="falcon-default" onClick={onClick} icon={faPlus} className={className}>
        Añadir {state.type_name}
      </ButtonIcon>
    );
  };

  const dropFinance = (id) => {
    Swal.fire({
      title: "¿Estas seguro?",
      text: "¿Quieres eliminar este gasto?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#9341af",
      cancelButtonColor: "#bbb",
      confirmButtonText: "Si, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.value) {
        try {
          const res = await deletefinance(id);
          if (res.code === SUCCESS_RESPONSE.OK) {
            Toast.fire({
              type: "success",
              title: `Se ha eliminado el gasto satisfactoriamente.`,
            });
            /*  history.push({
              pathname: `/dashboard/${moduleBase}/${selectedCondominium}/common-costs`,
              state: {
                type_id: state.type_id,
                type_name: state.type_name,
              },
            }); */
            setRefreshIndex((prev) => prev + 1);
          }
        } catch (error) {
          handleErrorMessage(error);
        }
      }
    });
  };

  const handleSeeSingleForm = () => {
    if (selectedCondominium) {
      history.push(`/dashboard/${childModuleBase}/${selectedCondominium}/form`);
    }
  };

  const handleDeactivate = async (cost) => {
    try {
      const { code } = await toggleIndividualStatus(cost.id, 0);

      if (code === SUCCESS_RESPONSE.OK) {
        Toast.fire({
          type: "success",
          title: `Gasto desactivado exitosamente.`,
        });
        setRefreshIndex((prev) => prev + 1);
        mutate();
        mutate2();
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const handleActivate = async (cost) => {
    try {
      const { code } = await toggleIndividualStatus(cost.id, 1);
      if (code === SUCCESS_RESPONSE.OK) {
        Toast.fire({
          type: "success",
          title: `Gasto activado exitosamente.`,
        });
        setRefreshIndex((prev) => prev + 1);
        mutate();
        mutate2();
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const ButtonActivateDeactivateFinances = ({ className }) => {
    const handleClick = async () => {
      try {
        const { code } = await activateOrDeactivateFinances(
          selectedCondominium,
          {
            type_id: state.type_id,
            active: 1,
          }
        );

        if (code === SUCCESS_RESPONSE.SUCCESFUL) {
          Toast.fire({
            title: "Gastos activados correctamente.",
            type: "success",
          });
          setRefreshIndex((prev) => prev + 1);
          mutate();
          mutate2();
        }
      } catch (error) {
        console.error("Error al activar/desactivar finanzas:", error);
      }
    };

    return (
      <ButtonIcon
        color={"falcon-success"}
        onClick={handleClick}
        icon={faToggleOn}
        className={className}
      >
        {"Activar gastos"}
      </ButtonIcon>
    );
  };

  return (
    <Fragment>
      <PageHeader
        title={state?.type_name}
        titleTag="h2"
        description="Gestiona y administra cada una de tus finanzas."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <Row>
          <Col xs={12}>
            <p className="text-left mb-0">Total de {state.type_name}:</p>
          </Col>
          <Col xs={12}>
            <h5 className="text-left text-primary">
              <NumberFormat
                prefix={`${baseCurrency.symbol} `}
                allowedDecimalSeparators={true}
                decimalScale={2}
                fixedDecimalScale={true}
                thousandSeparator={true}
                displayType="text"
                value={amount}
              />
            </h5>
          </Col>
        </Row>
        <SupportLink />
      </PageHeader>
      <OnboardingBanner steps={["expenses"]} />
      <Fragment>
        <Card>
          <FalconCardHeader title={state.type_name}>
            {state?.type_name === "Gastos extraordinarios" ||
              state?.type_name === "Gastos ordinarios" ? (
              <Row>
                <Col>
                  <Flex>
                    <Filter
                      keyField={"active"}
                      options={filter_options}
                      selectType={setParams}
                      dateFilter={true}
                    />
                  </Flex>
                </Col>
              </Row>
            ) : (
              <>
                <Row className="justify-content-end">
                  <Col xs="auto">
                    <Row className="justify-content-center mb-3">
                      <Col
                        xs="auto"
                        lg="auto"
                        md={12}
                        sm={12}
                        className="d-flex align-items-center justify-content-center"
                      >
                        <Label className="mb-0 mr-2">
                          <FontAwesomeIcon icon={faFilter} />
                        </Label>
                      </Col>
                      <Col
                        xs="auto"
                        sm="auto"
                        lg="auto"
                        className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                      >
                        <Label className="mr-2 mb-0">Desde</Label>
                        <Datetime
                          value={formDate.since}
                          isValidDate={(current, selected) => {
                            return !current.isAfter();
                          }}
                          onChange={(d) =>
                            setformDate((prev) => ({ ...prev, since: d }))
                          }
                          dateFormat="DD/MM/YYYY"
                          timeFormat={false}
                        />
                      </Col>
                      <Col
                        xs="auto"
                        sm="auto"
                        lg="auto"
                        className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                      >
                        <Label className="mr-2 mb-0">Hasta</Label>
                        <Datetime
                          value={formDate.to}
                          className="mr-2"
                          isValidDate={(current, selected) => {
                            return (
                              current.isAfter(formDate.since) &&
                              !current.isAfter()
                            );
                          }}
                          dateFormat="DD/MM/YYYY"
                          timeFormat={false}
                          onChange={(d) =>
                            setformDate((prev) => ({ ...prev, to: d }))
                          }
                        />
                      </Col>
                      <Col
                        xs="auto"
                        className="pl-0 d-flex align-items-md-end align-items-lg-center align-items-sm-end"
                      >
                        <ButtonIcon
                          className="text-nowrap d-sm-none d-lg-block"
                          disabled={!formDate.to}
                          icon={faSearch}
                          color="falcon-default"
                          onClick={() => {
                            setParams((prev) => {
                              return {
                                ...prev,
                                start_date: formDate.since.format("YYYY-MM-DD"),
                                end_date: formDate.to.format("YYYY-MM-DD"),
                              };
                            });
                          }}
                        >
                          Buscar
                        </ButtonIcon>
                        <Button
                          className="text-nowrap d-sm-block d-lg-none"
                          disabled={!formDate.to}
                          color="falcon-default"
                          onClick={() => {
                            setParams((prev) => {
                              return {
                                ...prev,
                                start_date: formDate.since.format("YYYY-MM-DD"),
                                end_date: formDate.to.format("YYYY-MM-DD"),
                              };
                            });
                          }}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            )}

            <hr />
            <div className="d-flex flex-wrap justify-content-end" style={{ gap: "0.5rem" }}>
              {(state?.type_id === 1 || state?.type_id === 2) && (
                <ButtonActivateDeactivateFinances className="text-nowrap flex-grow-1 flex-lg-grow-0" />
              )}
              <ButtonIcon
                className="text-nowrap flex-grow-1 flex-lg-grow-0"
                icon={faMoneyCheck}
                color="falcon-default"
                onClick={handleSeeSingleForm}
              >
                Previsualizar planilla
              </ButtonIcon>
              <ButtonIcon
                className="text-nowrap flex-grow-1 flex-lg-grow-0"
                icon={faFileExcel}
                color="falcon-default"
                onClick={() => setIsExpenseImportOpen(true)}
              >
                Importar gastos
              </ButtonIcon>
              <ButtonAdd
                className="flex-grow-1 flex-lg-grow-0"
                onClick={() =>
                  history.push({
                    pathname: `/dashboard/${moduleBase}/${selectedCondominium}/common-costs/create`,
                    state: {
                      type_id: state.type_id,
                      type_name: state.type_name,
                    },
                  })
                }
              />
            </div>
          </FalconCardHeader>

          <CardBody className="fs--1 p-0">
            <PreloadState cond={isIterableArray(data)} loading={isLoading}>
              {data.length > 0 ? (
                <>
                  {data.map((cost, index) => {
                    const sub = cost.sub_expenses?.[0];
                    const area = sub?.accounting_area;
                    const account = sub?.account_plan;

                    return (
                      <div key={index} className="px-3 shadow-none border-bottom">
                        <Row className="mb-3 mt-4">
                          <Col className="d-flex align-items-center">
                            <div className="media-body">
                              <div className="d-flex align-items-center mb-1">
                                <h6 className="mb-0 font-weight-semi-bold mr-2">
                                  <span className="text-900">
                                    <p className="m-0">{cost.name}</p>
                                  </span>
                                </h6>
                                {(area || account) && (
                                  <span className="badge badge-soft-primary border-primary fs--2">
                                    <FontAwesomeIcon icon={faTag} className="mr-1" />
                                    {area ? area.name : account.name}
                                  </span>
                                )}
                              </div>
                              <p className="m-0 text-500 fs--1">{cost.description}</p>
                              <p className="m-0 fs--2 text-400">
                                creada el{" "}
                                {moment(cost.created_at).format("DD-MM-YYYY")}
                              </p>
                            </div>
                          </Col>
                          <Col>
                            <Row>
                              <Col>
                                <p className="text-right fs--1 mb-0 font-weight-bold">Monto</p>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <h6 className="text-right mb-0">
                                  <NumberFormat
                                    prefix={`${baseCurrency.symbol} `}
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    thousandSeparator={true}
                                    displayType="text"
                                    value={cost.value}
                                  />
                                  <NumberFormat
                                    className="text-right d-block d-md-inline"
                                    displayType="text"
                                    allowedDecimalSeparators={true}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix={" | " + curr?.currency?.iso + " "}
                                    value={cost.value * resolveDisplayRate(cost)}
                                  />
                                </h6>
                              </Col>
                            </Row>
                          </Col>
                          <Col
                            xs="auto"
                            className="d-sm-flex align-items-center justify-content-end"
                          >
                            <UncontrolledDropdown
                              direction="left"
                              className="d-inline-block ml-2"
                            >
                              <DropdownToggle color="falcon-default" size="sm">
                                <FontAwesomeIcon icon="ellipsis-h" />
                              </DropdownToggle>
                              <DropdownMenu>
                                {(state.type_id === 1 || state.type_id === 2) && (
                                  <>
                                    {cost.is_active || (state.type_id === 2 && !cost.deleted_at) ? (
                                      <DropdownItem
                                        className="text-danger"
                                        onClick={() => handleDeactivate(cost)}
                                      >
                                        Desactivar
                                      </DropdownItem>
                                    ) : (
                                      <DropdownItem
                                        className="text-success"
                                        onClick={() => handleActivate(cost)}
                                      >
                                        Activar
                                      </DropdownItem>
                                    )}
                                  </>
                                )}
                                <DropdownItem
                                  onClick={() =>
                                    history.push({
                                      pathname: `/dashboard/${childModuleBase}/${id}/common-costs/edit/${cost.id}`,
                                      state: {
                                        type_id: state.type_id,
                                        type_name: state.type_name,
                                      },
                                    })
                                  }
                                >
                                  Editar
                                </DropdownItem>
                                {(state.type_id === 1 || state.type_id === 2) && (
                                  <>
                                    <DropdownItem divider />
                                    <DropdownItem
                                      className="text-danger"
                                      onClick={() => dropFinance(cost.id)}
                                    >
                                      Eliminar
                                    </DropdownItem>
                                  </>
                                )}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </>
              ) : (
                <Row className="p-card">
                  <Col>
                    <Alert color="info" className="mb-0">
                      Al parecer aún no hay cuentas para mostrar. Puedes crear
                      una ahora mismo pulsando el siguiente enlace
                      <Button
                        data-testid="Button"
                        tag={Link}
                        color="link"
                        size="sm"
                        className="ml-1 pl-0"
                        to={{
                          pathname: `/dashboard/${moduleBase}/${selectedCondominium}/common-costs/create`,
                          state: {
                            type_id: state?.type_id,
                            type_name: state?.type_name,
                          },
                        }}
                      >
                        Crear {state?.type_name}
                      </Button>
                    </Alert>
                  </Col>
                </Row>
              )}
              {/*               <Or value={false} cond={error ? "error" : "ok"}>
                <Or value={"error"}>
                  <Row className="p-card">
                    <Col>
                      <Alert color="danger" className="mb-0">
                        Esta página no está disponible
                        <Button
                          data-testid="Button"
                          color="link"
                          size="sm"
                          className="ml-1 pl-0"
                          onClick={() => {
                            setRedirectUrl(`/dashboard/finance`);
                            setRedirect(true);
                          }}
                        >
                          Volver
                        </Button>
                      </Alert>
                    </Col>
                  </Row>
                </Or>
                <Or value={"ok"}>
                  
                </Or>
              </Or> */}
              {showPagination && (
                /*      <CardFooter className="border-top"> */
                <FullPagination
                  nextPage={nextPage}
                  prevPage={previousPage}
                  goToPage={goToPage}
                  meta={meta}
                  className={"shadow-none"}
                  posText={state.type_name}
                  perPage={perPage}
                />
                /*       </CardFooter> */
              )}
            </PreloadState>
          </CardBody>
        </Card>
        <ExpenseImportModal
          isOpen={isExpenseImportOpen}
          toggle={() => setIsExpenseImportOpen(false)}
          selectedCondominium={selectedCondominium}
          onSuccess={() => {
            mutate();
            mutate2();
          }}
        />
      </Fragment>
    </Fragment >
  );
};

CommonCosts.propTypes = {
  showPagination: PropTypes.bool,
};

export default withRedirect(CommonCosts);
